module.exports = __webpack_public_path__ + "static/media/hotel_package.205e7fc1.png";